import { useMemo } from 'react';
import { applyMiddleware, createStore } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import thunkMiddleware from 'redux-thunk';
import rootReducer from './reducers/rootReducer';

let store;

export function initStore(initialState) {
  return createStore(
    rootReducer,
    initialState,
    composeWithDevTools(applyMiddleware(thunkMiddleware)),
  );
}

export const initializeStore = (preloadedState) => {
  /* eslint-disable-next-line */
  let _store = initStore(preloadedState);

  if (store && preloadedState) _store = initStore(Object.assign(store.getState(), preloadedState));
  if (store) _store = store;

  // After navigating to a page with an initial Redux state, merge that state
  // with the current state in the store, and create a new store
  // if (preloadedState && store) {
  //   const oldStore = _store.getState();
  //   let newState = {};
  //   /* eslint-disable-next-line */
  //   for (const key in preloadedState) {
  //     if (oldStore[key] !== undefined) {
  //       newState = { [key]: Object.assign(store.getState()[key], preloadedState[key]) };
  //     }
  //   }
  //
  //   _store = initStore({
  //     ...newState,
  //     ...store.getState(),
  //   });
  //   // Reset the current store
  //   store = undefined;
  // }

  // For SSG and SSR always create a new store
  if (typeof window === 'undefined') return _store;
  // Create the store once in the client
  store = _store;

  return _store;
};

export function useStore(initialState) {
  return useMemo(() => initializeStore(initialState), [initialState]);
}
